// extracted by mini-css-extract-plugin
export default {"deviceExpired":"styles_deviceExpired__xk3jN"};